import { createContext } from 'react';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: any = [];

const DeveloperGroupContext = createContext(defaultState);

export default DeveloperGroupContext;
